import { Pin } from 'lucide-react'
import { TooltipContent, Tooltip, TooltipTrigger } from '@wellesley/ui'

type PinnedLabelProps = {
  isReplyFeed: boolean
}

const PinnedLabel = ({ isReplyFeed }: PinnedLabelProps) => (
  <Tooltip disableHoverableContent>
    <TooltipTrigger className="h-5" data-testid="pinned-post-tag" asChild>
      <Pin
        size={16}
        color="var(--blue-500)"
        className="m-auto cursor-pointer"
      />
    </TooltipTrigger>
    <TooltipContent theme="dark" size="small" align="center">
      {isReplyFeed ? 'Highlighted reply' : 'Pinned post'}
    </TooltipContent>
  </Tooltip>
)

export default PinnedLabel
